module.exports = __webpack_public_path__ + "static/img/oil-card-recharge.6cf8379.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/my/oil-card-recharge.png
// module id = 3BAi
// module chunks = 1